<template>
  <div>
    <div>
      <v-btn icon :to="{ name: 'diario-escolar', params: { paginaAtualTurmas }}" class="mt-3">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert v-if="dadosEnturmacao.length == 0" class="mt-3" type="error" value="true" style="color: white;">
      <div>Enturmação não encontrada!</div>
    </v-alert>
    <v-card class="pa-3 mt-3" v-else>
       <table class="table-siged">
         <thead>
           <tr>
             <th>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
                  </template>
                  <span class="text-caption white--text">Dê um duplo clique no nome do aluno abaixo para visualizar <br>informações de contato sobre o respectivo aluno.</span>
                </v-tooltip>
               Aluno
              </th>
             <th>Nota Total</th>
              <th>
               <span>Total de Faltas</span>
               <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" size="20" >notification_important</v-icon>
                  </template>
                  <span class="text-caption white--text">Total de Faltas, inclusive as justificadas por atestado médico. </span>
                </v-tooltip>
             </th>
           </tr>
         </thead>
         <tbody>
          <tr v-for="aluno in dadosEnturmacao" :key="aluno.id">
            <td style="cursor: pointer;" @dblclick="dadosContatoAluno = {dialog: true, cdtipesc: $store.getters.school.cdtipesc, cdescola: $store.getters.school.cdescola, numatalun: aluno.numatalun};">{{aluno.nmaluno}}</td>
            <td v-if="aluno.invalido" colspan="2" class="centro">{{ aluno.invalido }} <span v-if="aluno.dtafastam"> - {{ aluno.dtafastam | formatDataBR }}</span></td>
            <template v-else>
              <td class="centro">
                <span v-if="aluno.pdi && aluno.pdi_avaliado == 'N'">PDI</span>
                <span v-else>{{ aluno.totalNotas | formatNumber }}</span>
              </td>
              <td class="centro">{{ aluno.totalFaltas | formatNumber }}</td>
            </template>
           </tr>
         </tbody>
       </table>
    </v-card>

     <ContatoAluno v-bind.sync="dadosContatoAluno" />

  </div>
</template>

<script>
import ContatoAluno from '@/components/ContatoAluno';
import store from '@/store/index';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});


export default {
  name: 'TotalizadorNota',
  components: {
    ContatoAluno
  },
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    paginaAtualTurmas: [String, Number],
  },
  data (){
    return {
      dadosEnturmacao: [],
      dadosContatoAluno: {},
    };

  },
  async beforeRouteEnter(to, from, next){
    if(typeof to.params.ano === 'undefined' || typeof to.params.cdturma === 'undefined' || typeof to.params.disciplina === 'undefined'){
      return next('/diario-escolar');
    }

    const { data } = await DiarioEscolarRepository.getTotalizadorNotasFrequencia({
      ...dadosUser(),
      aaletivo: to.params.ano,
      cdturma: to.params.cdturma,
      cddiscipl: to.params.disciplina,
    });

    return next(vm => {
      vm.load(data);
    });
  },
  methods: {
    load (data) {
      this.dadosEnturmacao = data.results;
      this.$Progress.finish();
    },
  },
}
</script>

<style>

</style>
